"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _ModalBase = _interopRequireDefault(require("./ModalBase"));
var _ModalHeader = _interopRequireDefault(require("../ModalHeader"));
var _ModalBody = _interopRequireDefault(require("../ModalBody"));
var _ModalFooter = _interopRequireDefault(require("../ModalFooter"));
var _Button = _interopRequireDefault(require("../Button"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var defaultProps = {
  title: '',
  theme: {}
};

/**
 * Displays a modal window with a body, header and footer.
 */
var Modal = exports["default"] = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(Modal, _React$Component);
  function Modal() {
    (0, _classCallCheck2["default"])(this, Modal);
    return _callSuper(this, Modal, arguments);
  }
  (0, _createClass2["default"])(Modal, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        renderInBody = _this$props.renderInBody,
        title = _this$props.title,
        onSubmit = _this$props.onSubmit,
        onCancel = _this$props.onCancel,
        className = _this$props.className,
        testId = _this$props.testId,
        refCallback = _this$props.refCallback,
        onEsc = _this$props.onEsc,
        onClickOverlay = _this$props.onClickOverlay,
        onEnter = _this$props.onEnter,
        children = _this$props.children,
        innerRef = _this$props.innerRef,
        isDanger = _this$props.isDanger,
        theme = _this$props.theme,
        role = _this$props.role,
        ariaDescribedBy = _this$props.ariaDescribedBy,
        ariaLabelledBy = _this$props.ariaLabelledBy;
      var isUsingShorthands = title && onSubmit && onCancel;
      // if the user passes shorthands, render using default modal configuration
      if (isUsingShorthands) {
        return /*#__PURE__*/_react["default"].createElement(_ModalBase["default"], {
          innerRef: innerRef,
          theme: theme,
          className: className,
          testId: testId,
          onEnter: onSubmit,
          onEsc: onCancel,
          onClickOverlay: onCancel,
          renderInBody: renderInBody,
          role: role,
          ariaLabel: title,
          ariaDescribedBy: ariaDescribedBy,
          ariaLabelledBy: ariaLabelledBy,
          ref: function ref(node) {
            if (refCallback && typeof refCallback === 'function') {
              refCallback(node);
            }
          }
        }, /*#__PURE__*/_react["default"].createElement(_ModalHeader["default"], {
          testId: testId && "modal-header-".concat(testId),
          isDanger: isDanger,
          theme: theme.ModalHeader
        }, /*#__PURE__*/_react["default"].createElement("h1", null, title)), /*#__PURE__*/_react["default"].createElement(_ModalBody["default"], {
          testId: testId && "modal-body-".concat(testId),
          theme: theme.ModalBody
        }, children), /*#__PURE__*/_react["default"].createElement(_ModalFooter["default"], {
          testId: testId && "modal-footer-".concat(testId),
          theme: theme.ModalFooter
        }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
          theme: theme.Button,
          onClick: onCancel,
          kind: "tertiary",
          noFill: true,
          testId: testId && "modal-cancel-".concat(testId)
        }, "Cancel"), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
          theme: theme.Button,
          onClick: onSubmit,
          kind: isDanger ? 'danger' : 'primary',
          testId: testId && "modal-submit-".concat(testId)
        }, "Ok")));
      }

      // Log warning if missing shorthands
      if (title || onSubmit || onCancel) {
        logWarning(title, onSubmit, onCancel); // eslint-disable-line
      }

      // if not using shorthands, just render children
      return /*#__PURE__*/_react["default"].createElement(_ModalBase["default"], {
        theme: theme,
        innerRef: innerRef,
        ref: function ref(node) {
          if (refCallback && typeof refCallback === 'function') {
            refCallback(node);
          }
        },
        className: className,
        testId: testId,
        renderInBody: renderInBody,
        onEnter: onEnter,
        onEsc: onEsc,
        onClickOverlay: onClickOverlay,
        role: role,
        ariaLabel: title,
        ariaDescribedBy: ariaDescribedBy,
        ariaLabelledBy: ariaLabelledBy
      }, children);
    }
  }]);
  return Modal;
}(_react["default"].Component);
(0, _defineProperty2["default"])(Modal, "defaultProps", defaultProps);
function logWarning(title, onSubmit, onCancel) {
  var present = [];
  var missing = [];
  (title ? present : missing).push('title');
  (onSubmit ? present : missing).push('onSubmit');
  (onCancel ? present : missing).push('onCancel');
  // eslint-disable-next-line
  console.warn("\n    Warning: when using shorthands, all of them must be used.\n    You are using '".concat(present.join('\' and \''), "', but '").concat(missing.join('\' and \''), "' ").concat(missing.length > 1 ? 'are' : 'is', " missing.\n  "));
}
//# sourceMappingURL=Modal.js.map